//
// YUP SHOULD ONLY EXIST IN THIS FILE!
// NEVER PASS YUP OBJECTS OR IMPORTS OUTSIDE!
//
import { array, object, string, number, boolean } from 'yup';
import { returnErrorWithEmptyPayload, returnNoErrorWithPayload } from '..';
import { sanitize_userOrGroupPickerQuery } from '../util';
import { returnError400WithEmptyPayload, } from './model';
export const REGEX_VALID_CUSTOMFIELD_ID = /^customfield_[0-9]+$/;
export const REGEX_VALID_DEFAULT_OPTION_ID = /^[0-9]+$/;
export const __yupValidatonErrorToCCError = (ve) => {
    return {
        hasError: true,
        statusCode: 400,
        errorMessage: ve.message,
        errorId: 'VALERR_000000',
        payload: null,
    };
};
export const validateInvokeParams_OptionDTOGetCustomFieldContextWithDefaultOption = async (params) => {
    const schema = object({
        fieldId: string().required().matches(REGEX_VALID_CUSTOMFIELD_ID, 'invalid fieldId format'),
        contextId: number().required().positive().integer(),
    }).noUnknown(true);
    try {
        await schema.validate(params, { strict: true });
        return returnNoErrorWithPayload(params);
    }
    catch (err) {
        return returnErrorWithEmptyPayload(__yupValidatonErrorToCCError(err));
    }
};
export const validateInvokeParams_OptionDTOGetOptions = async (params) => {
    const schema = object({
        fieldId: string().required().matches(REGEX_VALID_CUSTOMFIELD_ID, 'invalid fieldId format'),
        contextId: number().required().positive().integer(),
        parentOptionId: number().optional().positive().integer(),
    }).noUnknown(true);
    try {
        await schema.validate(params, { strict: true });
        return returnNoErrorWithPayload(params);
    }
    catch (err) {
        return returnErrorWithEmptyPayload(__yupValidatonErrorToCCError(err));
    }
};
export const validateInvokeParams_OptionDTOCreateOption = async (params) => {
    const schema = object({
        fieldId: string().required().matches(REGEX_VALID_CUSTOMFIELD_ID, 'invalid fieldId format'),
        contextId: number().required().positive().integer(),
        parentOptionId: number().optional().positive().integer(),
        create: object({
            value: string().required().min(1).max(500),
            disabled: boolean().optional(),
        }).noUnknown(true),
    }).noUnknown(true);
    try {
        await schema.validate(params, { strict: true });
        return returnNoErrorWithPayload(params);
    }
    catch (err) {
        return returnErrorWithEmptyPayload(__yupValidatonErrorToCCError(err));
    }
};
export const validateInvokeParams_DTOSetDefaultOption = async (params) => {
    const schema = object({
        fieldId: string().required().matches(REGEX_VALID_CUSTOMFIELD_ID, 'invalid fieldId format'),
        contextId: number().required().positive().integer(),
        doFullDelete: boolean().required(),
        optionId: string().optional().nullable().matches(REGEX_VALID_DEFAULT_OPTION_ID, 'invalid optionId format'),
        childOptionId: string().optional().nullable().matches(REGEX_VALID_DEFAULT_OPTION_ID, 'invalid optionId format'),
        optionIds: array().of(string().matches(REGEX_VALID_DEFAULT_OPTION_ID, 'invalid optionId format')).optional().nullable(),
    }).noUnknown(true);
    try {
        await schema.validate(params, { strict: true });
        return returnNoErrorWithPayload(params);
    }
    catch (err) {
        return returnErrorWithEmptyPayload(__yupValidatonErrorToCCError(err));
    }
};
export const validateInvokeParams_DTOGetSingleOptionOfContext = async (params) => {
    const schema = object({
        fieldId: string().required().matches(REGEX_VALID_CUSTOMFIELD_ID, 'invalid fieldId format'),
        contextId: number().required().positive().integer(),
        optionId: number().required().positive().integer(),
    }).noUnknown(true);
    try {
        await schema.validate(params, { strict: true });
        return returnNoErrorWithPayload(params);
    }
    catch (err) {
        return returnErrorWithEmptyPayload(__yupValidatonErrorToCCError(err));
    }
};
export const validateInvokeParams_OptionDTOMoveOption = async (params) => {
    const schema = object({
        fieldId: string().required().matches(REGEX_VALID_CUSTOMFIELD_ID, 'invalid fieldId format'),
        contextId: number().required().positive().integer(),
        parentOptionId: number().optional().positive().integer(),
        move: object({
            id: number().required().positive().integer(),
            after: number().optional().positive().integer(),
            position: string().optional().oneOf(['First', 'Last']),
        }).noUnknown(true),
    }).noUnknown(true);
    try {
        await schema.validate(params, { strict: true });
        return returnNoErrorWithPayload(params);
    }
    catch (err) {
        return returnErrorWithEmptyPayload(__yupValidatonErrorToCCError(err));
    }
};
export const validateInvokeParams_OptionDTODeleteOption = async (params) => {
    const schema = object({
        fieldId: string().required().matches(REGEX_VALID_CUSTOMFIELD_ID, 'invalid fieldId format'),
        contextId: number().required().positive().integer(),
        parentOptionId: number().optional().positive().integer(),
        delete: object({
            id: number().required().positive().integer(),
        }).noUnknown(true),
    }).noUnknown(true);
    try {
        await schema.validate(params, { strict: true });
        return returnNoErrorWithPayload(params);
    }
    catch (err) {
        return returnErrorWithEmptyPayload(__yupValidatonErrorToCCError(err));
    }
};
export const validateInvokeParams_OptionDTOUpdateOption = async (params) => {
    const schema = object({
        fieldId: string().required().matches(REGEX_VALID_CUSTOMFIELD_ID, 'invalid fieldId format'),
        contextId: number().required().positive().integer(),
        parentOptionId: number().optional().positive().integer(),
        update: object({
            id: number().required().positive().integer(),
            value: string().required().min(1).max(500),
            disabled: boolean().optional(),
        }).noUnknown(true),
    }).noUnknown(true);
    try {
        await schema.validate(params, { strict: true });
        return returnNoErrorWithPayload(params);
    }
    catch (err) {
        return returnErrorWithEmptyPayload(__yupValidatonErrorToCCError(err));
    }
};
export const validateInvokeParams_RestGetAllCustomFields = async (params) => {
    if (params === null) {
        return returnNoErrorWithPayload(params);
    }
    //
    // SANITIZE
    //
    if (params.currentFilter === '') {
        params.currentFilter = null;
    }
    //
    // VALIDATE
    //
    const schema = object({
        startAt: number().required().positive().integer().min(0).max(100000),
        maxResults: number().required().positive().integer().min(5).max(50),
        currentFilter: string().notRequired().min(1).max(500),
    }).noUnknown(true);
    try {
        await schema.validate(params, { strict: true });
        return returnNoErrorWithPayload(params);
    }
    catch (err) {
        return returnErrorWithEmptyPayload(__yupValidatonErrorToCCError(err));
    }
};
export const validateInvokeParams_RestGetAllCustomFieldContexts = async (params) => {
    if (params === null || params === undefined) {
        return returnError400WithEmptyPayload('invoke params cannot be null', 'PARMNLL_7348321');
    }
    //
    // SANITIZE
    //
    if (params.currentFilter === '') {
        params.currentFilter = null;
    }
    //
    // VALIDATE
    //
    const schema = object({
        fieldId: string().required().matches(REGEX_VALID_CUSTOMFIELD_ID, 'invalid fieldId format'),
        startAt: number().required().positive().integer().min(0).max(100000),
        maxResults: number().required().positive().integer().min(5).max(50),
        currentFilter: string().notRequired().min(1).max(500),
    }).noUnknown(true);
    try {
        await schema.validate(params, { strict: true });
        return returnNoErrorWithPayload(params);
    }
    catch (err) {
        return returnErrorWithEmptyPayload(__yupValidatonErrorToCCError(err));
    }
};
export const validateInvokeParams_PermissionEditorDTOGetFieldPermissions = async (params) => {
    if (params === null || params === undefined) {
        return returnError400WithEmptyPayload('invoke params cannot be null', 'PARMNLL_237321');
    }
    //
    // VALIDATE
    //
    const schema = object({
        fieldId: string().required().matches(REGEX_VALID_CUSTOMFIELD_ID, 'invalid fieldId format'),
        contextId: number().positive().integer().nullable().defined(),
        startAt: number().required().positive().integer().min(0).max(100000),
        maxResults: number().required().positive().integer().min(5).max(100),
    }).noUnknown(true);
    try {
        await schema.validate(params, { strict: true });
        return returnNoErrorWithPayload(params);
    }
    catch (err) {
        return returnErrorWithEmptyPayload(__yupValidatonErrorToCCError(err));
    }
};
export const validateInvokeParams_PermissionEditorDTOUserOrGroupPickerQuery = async (params) => {
    if (params === null || params === undefined) {
        return returnError400WithEmptyPayload('invoke params cannot be null', 'PARMNLL_2238377');
    }
    //
    // SANITIZE (Let the user type in whatever he wants without error!)
    //
    const newParams = { ...params };
    newParams.query = sanitize_userOrGroupPickerQuery(params.query);
    //
    // VALIDATE
    //
    const schema = object({
        query: string()
            .required()
            .min(1)
            .max(500)
            .matches(/^[-:.,;_\p{Zs}\p{L}\p{N}]+$/gu, 'invalid query format'), // \p{L} and /gu allows all printable characters from any language
    }).noUnknown(true);
    try {
        await schema.validate(newParams, { strict: true });
        return returnNoErrorWithPayload(newParams);
    }
    catch (err) {
        return returnErrorWithEmptyPayload(__yupValidatonErrorToCCError(err));
    }
};
